// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"05933501","87":"cd5815b0","301":"8fe67afd","361":"4e8c267a","372":"c032affe","404":"9423c3f3","421":"241714e8","507":"84ccaf69","520":"c6844ea5","642":"3c414362","658":"833d78a5"}[chunkId] + ".js";
};